<template>
  <v-data-table
    :headers="tableHeaders"
    :hide-default-header="hideDefaultHeader"
    :items="items"
    :items-per-page="-1"
    class="b-radius-0 b-1 bc-outlined-gray"
    density="compact"
    hide-default-footer
  >
    <template #[`item.key`]="{ item }">
      <span
        v-text="item.key"
        class="text-medium-emphasis"
      />
    </template>

    <template #[`item.value`]="{ item }">
      <span :data-testid="item.key">
        <LongDateTime
          v-if="item.asLongDateTime && item.value"
          :date="item.value"
        />
        <span
          v-else-if="hasValue(item.value)"
          v-text="item.value"
          :class="{ 'text-break': item.asBreakable || item.asCode }"
        />
        <span v-else>{{ nullText }}</span>
      </span>
    </template>
  </v-data-table>
</template>

<script setup>
import LongDateTime from '@/shared/components/LongDateTime.vue';

const props = defineProps({
  headers: {
    type: Array,
    default: () => [],
  },
  items: {
    type: Array,
    default: () => [],
  },
  nullText: {
    type: String,
    default: '—',
  },
  keyTitle: {
    type: String,
    default: undefined,
  },
  keyWidth: {
    type: String,
    default: '40%',
  },
  valueTitle: {
    type: String,
    default: undefined,
  },
});

const hideDefaultHeader = computed(
  () => props.headers.length === 0 && !props.keyTitle && !props.valueTitle,
);

const tableHeaders = computed(() => {
  if (props.headers.length > 0) {
    return props.headers;
  }

  return [
    {
      title: props.keyTitle || 'Setting',
      value: 'key',
      sortable: false,
      width: props.keyWidth,
    },
    {
      title: props.valueTitle || 'Value',
      value: 'value',
      sortable: false,
    },
  ];
});

function hasValue(value) {
  return value != null && value !== '';
}
</script>
